import { Controller } from "@hotwired/stimulus"

// Manages the audio versions card on the media show page. Each version
// (Audio narration / Podcast) lives in its own pane with its own audio
// element + transcript, so switching tabs just means showing/hiding panes
// and pausing the previously-active audio.
export default class extends Controller {
  static targets = ["tab", "pane", "transcript", "transcriptToggle"]
  static values = { active: { type: Number, default: 0 } }

  connect() {
    this._showPane(this.activeValue)
  }

  // Tab click: switch to the requested version.
  select(event) {
    const tab = event.currentTarget
    const index = Number(tab.dataset.index)
    if (!Number.isFinite(index) || index === this.activeValue) return

    this._pausePane(this.activeValue)
    this.activeValue = index
    this._showPane(index)
  }

  // Toggle the transcript visibility within the pane that owns this button.
  toggleTranscript(event) {
    const button = event.currentTarget
    const pane = button.closest(".audio-versions-pane")
    if (!pane) return

    const transcript = pane.querySelector('[data-audio-versions-target="transcript"]')
    if (!transcript) return

    const willOpen = transcript.hasAttribute("hidden")
    if (willOpen) {
      transcript.removeAttribute("hidden")
      button.classList.add("is-open")
      button.setAttribute("aria-expanded", "true")
    } else {
      transcript.setAttribute("hidden", "")
      button.classList.remove("is-open")
      button.setAttribute("aria-expanded", "false")
    }
  }

  // -- Internals -----------------------------------------------------------
  _showPane(index) {
    this.paneTargets.forEach((pane) => {
      const i = Number(pane.dataset.index)
      const active = i === index
      pane.classList.toggle("is-active", active)
      if (active) {
        pane.removeAttribute("hidden")
      } else {
        pane.setAttribute("hidden", "")
      }
    })

    this.tabTargets.forEach((tab) => {
      const i = Number(tab.dataset.index)
      const active = i === index
      tab.classList.toggle("is-active", active)
      tab.setAttribute("aria-selected", String(active))
    })
  }

  _pausePane(index) {
    const pane = this.paneTargets.find((p) => Number(p.dataset.index) === index)
    if (!pane) return
    pane.querySelectorAll("audio").forEach((audio) => {
      try { audio.pause() } catch (_) { /* noop */ }
    })
  }
}
